/****
 * Layout component for authentication pages
 * such as login and sign-in flows.
 */
import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200">
      <div className="w-full max-w-[420px]">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
